import { Badge } from '@cloudscape-design/components';
import { LotStatus } from '@parallel-fluidics/shared/constants';
import PropTypes from 'prop-types';
import React from 'react';

const LotStatusColorMap = Object.freeze({
  [LotStatus.AWAITING_INSPECTION]: 'severity-medium',
  [LotStatus.SEALED]: 'blue',
  [LotStatus.OPEN]: 'green',
  [LotStatus.EMPTY]: 'grey',
  [LotStatus.QUARANTINED]: 'red',
});

export default function LotStatusBadge({ status = null }) {
  return (
    <Badge color={LotStatusColorMap[status] || 'grey'}>
      {status || 'unknown'}
    </Badge>
  );
}

LotStatusBadge.propTypes = {
  status: PropTypes.oneOf(Object.values(LotStatus)),
};
